import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../css/main.css';

// Import React Icons
import { FiPhone, FiMail, FiCalendar } from 'react-icons/fi';

import mainlogo from '../assets/images/main-logo.svg';
import logofacebook from '../assets/images/logo-facebook.svg';
import logonike from '../assets/images/logo-nike.svg';
import logosamsung from '../assets/images/logo-samsung.svg';
import logodisney from '../assets/images/logo-disney.svg';
import heroillustration from '../assets/images/hero-illustration-contact.svg';


import deshicoast from '../assets/images/logo-deshicoast.png';
import fiorra from '../assets/images/logo-fiorra.png';
import birdclub from '../assets/images/logo-birdclub.png';
import womenli from '../assets/images/logo-womenli.png';



const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        companySize: '1',
        country: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState('');

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const navigate = useNavigate();

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus('');

        try {
            // EmailJS configuration - using your actual IDs
            const serviceId = 'service_s054gv9';
            const templateId = 'template_dj4lmag';
            const publicKey = '1wo_JqwMQf6ENw8GE';

            // Template parameters to send
            const templateParams = {
                to_email: 'swastikofficial@gmail.com', // Replace with admin email
                from_name: `${formData.firstName} ${formData.lastName}`,
                from_email: formData.email,
                company_size: formData.companySize,
                country: formData.country,
                message: formData.message,
                subject: 'New Contact Form Submission'
            };

            // Send email using EmailJS
            const response = await emailjs.send(serviceId, templateId, templateParams, publicKey);
            console.log('Email sent successfully:', response);

            toast.success('Message sent successfully! We\'ll get back to you soon.');
            // Reset form
            setFormData({
                firstName: '',
                lastName: '',
                email: '',
                companySize: '1',
                country: '',
                message: ''
            });
        } catch (error) {
            console.error('EmailJS Error:', error);
            toast.error('Failed to send message. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            {/* Page wrapper */}
            <div className="c29n1 cfi8v cklpe co3fs">
                {/* Site header */}
                <header className="cx5bd csam5 cjkjb">
                    <div className="cdcfy cl9ye chlof cc8xx">
                        <div className="c29n1 cx10f c38qt crjhh coh5t">
                            {/* Site branding */}
                            <div className="cpmys ce0su">
                                {/* Logo */}
                                <a className="c4ozt" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} aria-label="Logo">
                                    <img src={mainlogo} width={50} height={50} alt="Logo" />
                                </a>
                            </div>
                        </div>
                    </div>
                </header>
                {/* Page content */}
                <main className="c7e8i">
                    <section>
                        <div className="cdcfy cl9ye chlof cc8xx">
                            <div className="cmprh czcbq c823vn c6lgd">
                                <div className="cu831 cf4lx ca0tr">
                                    {/* Left side */}
                                    <div className="c6l03 lg:bg-transparent bg-white cjqzn c88x7 ">
                                        <div className="c7e8i clpz0 cwe4v cfe0z c226t w-full flex flex-col items-center">
                                            <h1 className="caveb ceonn text-center">Contact Us</h1>

                                            {/* Contact Hero Section */}
                                            <div className="c8glp w-full max-w-3xl">
                                                <ul className="c98p9 cklpe czlr6 c3z20">
                                                    <li className="c29n1 c38qt cjmb3">
                                                        <svg className="cqma5 ce0su" width={20} height={20} xmlns="http://www.w3.org/2000/svg">
                                                            <circle className="c5gfx" cx={10} cy={10} r={10} />
                                                            <path className="ci3vc" d="M15.335 7.933 14.87 7c-4.025 1.167-6.067 3.733-6.067 3.733l-1.867-1.4-.933.934L8.802 14c2.158-4.025 6.533-6.067 6.533-6.067Z" />
                                                        </svg>
                                                        <span>A dedicated Team will build your online store as per your taste</span>
                                                    </li>
                                                    <li className="c29n1 c38qt cjmb3">
                                                        <svg className="cqma5 ce0su" width={20} height={20} xmlns="http://www.w3.org/2000/svg">
                                                            <circle className="c5gfx" cx={10} cy={10} r={10} />
                                                            <path className="ci3vc" d="M15.335 7.933 14.87 7c-4.025 1.167-6.067 3.733-6.067 3.733l-1.867-1.4-.933.934L8.802 14c2.158-4.025 6.533-6.067 6.533-6.067Z" />
                                                        </svg>
                                                        <span>Dedicated Account Manager and Post Launch Support</span>
                                                    </li>
                                                    <li className="c29n1 c38qt cjmb3">
                                                        <svg className="cqma5 ce0su" width={20} height={20} xmlns="http://www.w3.org/2000/svg">
                                                            <circle className="c5gfx" cx={10} cy={10} r={10} />
                                                            <path className="ci3vc" d="M15.335 7.933 14.87 7c-4.025 1.167-6.067 3.733-6.067 3.733l-1.867-1.4-.933.934L8.802 14c2.158-4.025 6.533-6.067 6.533-6.067Z" />
                                                        </svg>
                                                        <span>Affordable Hosting Plans with maintenance included</span>
                                                    </li>
                                                </ul>
                                            </div>

                                            {/* Contact Information Row */}
                                            <div className=" w-full max-w-3xl">
                                                <div className="flex flex-col sm:flex-row gap-6 sm:gap-8 justify-center">
                                                    {/* Phone */}
                                                    <div className="flex flex-col items-center gap-3">
                                                        <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full">
                                                            <FiPhone className="w-5 h-5 text-gray-600" />
                                                        </div>
                                                        <div className="text-center">
                                                            <p className="text-sm font-medium text-gray-900">Call us</p>
                                                            <a
                                                                href="tel:+917718837352"
                                                                className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200"
                                                            >
                                                                +91 77188 37352
                                                            </a>
                                                        </div>
                                                    </div>

                                                    {/* Email */}
                                                    <div className="flex flex-col items-center gap-3">
                                                        <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full">
                                                            <FiMail className="w-5 h-5 text-gray-600" />
                                                        </div>
                                                        <div className="text-center">
                                                            <p className="text-sm font-medium text-gray-900">Email us</p>
                                                            <a
                                                                href="mailto:contact@craftmystore.com"
                                                                className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200"
                                                            >
                                                                contact@craftmystore.com
                                                            </a>
                                                        </div>
                                                    </div>

                                                    {/* Calendly */}
                                                    <div className="flex flex-col items-center gap-3">
                                                        <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full">
                                                            <FiCalendar className="w-5 h-5 text-gray-600" />
                                                        </div>
                                                        <div className="text-center">
                                                            <p className="text-sm font-medium text-gray-900">Schedule a call</p>
                                                            <a
                                                                href="https://calendly.com/swastikofficial24/30min"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200"
                                                            >
                                                                Book a meeting
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Press logos */}
                                            {/* <div className="cjkjb w-full max-w-3xl mt-12 mt-8">
                                                <div className="c755p clpz0 cwyp8 cnxvz cff69 c6nbq cwiv0 c226t text-center">Trusted By</div>
                                                <div className="cc2i9 c29n1 c3d4t c38qt cxwmo c919v cf5hq c0b1p">
                                                    {/-* Deshicoast *-/}
                                                    <div className="cbihh cu4gs clzlu">
                                                        <img className="c98p9 cb320" src={deshicoast} width={99} height={19} alt="Deshicoast" />
                                                    </div>
                                                    {/-* Womenli *-/}
                                                    <div className="cbihh cu4gs clzlu">
                                                        <img className="c98p9 cb320" src={womenli} width={64} height={23} alt="Womenli" />
                                                    </div>
                                                    {/-* fiorra *-/}
                                                    <div className="cbihh cu4gs clzlu">
                                                        <img className="c98p9 cb320" src={fiorra} width={95} height={32} alt="Fiorra" />
                                                    </div>
                                                    {/-* Birds Club Clothing *-/}
                                                    <div className="cbihh cu4gs clzlu">
                                                        <img className="c98p9 cb320" src={birdclub} width={86} height={36} alt=" Birds Club Clothing" />
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                    {/* Right side */}
                                    <div className="cyhno ce0su clpz0 c226t">
                                        {/* Bg */}
                                        <div className="cistn cx5bd ctehq cakxp c88x7 cf5et chf8c ch1vk c5aqy c43am cjqzn ckk3f catjv c0jii" aria-hidden="true" />
                                        {/* Illustration */}
                                        <img className="cistn cx5bd c08f2 cfhlr cakxp cr579 czw6c cs15f cleik c89jy cb6o0" src={heroillustration} width={960} height={960} aria-hidden="true" />
                                        <div className="c29n1 c4i6y c2xto c9ob8 cdc85">
                                            <div className="cdcfy cjkjb cbo7w c36be c5att cbjbi cqqyw cy215 c7e3v c84ry">
                                                {/* Form */}
                                                <form onSubmit={handleSubmit}>
                                                    <div className="cf5tr">
                                                        <div className="cdjl1 crjhh c5mm2 c896x">
                                                            <label className="cc9lh cw7u7 c4ozt cjmb3 c62tk c50dd cq72s c65xn cusnp" htmlFor="first-name">First name</label>
                                                            <div className="ce0su c1dbb cvs2y">
                                                                <input
                                                                    id="first-name"
                                                                    name="firstName"
                                                                    className="cfjie cjkjb cmxc3 c62tk"
                                                                    type="text"
                                                                    placeholder="Patrick"
                                                                    value={formData.firstName}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="cdjl1 crjhh c5mm2 c896x">
                                                            <label className="cc9lh cw7u7 c4ozt cjmb3 c62tk c50dd cq72s c65xn cusnp" htmlFor="last-name">Last name</label>
                                                            <div className="ce0su c1dbb cvs2y">
                                                                <input
                                                                    id="last-name"
                                                                    name="lastName"
                                                                    className="cfjie cjkjb cmxc3 c62tk"
                                                                    type="text"
                                                                    placeholder="Mills"
                                                                    value={formData.lastName}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="cdjl1 crjhh c5mm2 c896x">
                                                            <label className="cc9lh cw7u7 c4ozt cjmb3 c62tk c50dd cq72s c65xn cusnp" htmlFor="email">Work email</label>
                                                            <div className="ce0su c1dbb cvs2y">
                                                                <input
                                                                    id="email"
                                                                    name="email"
                                                                    className="cfjie cjkjb cmxc3 c62tk"
                                                                    type="email"
                                                                    placeholder="patrick@example.com"
                                                                    value={formData.email}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="cdjl1 crjhh c5mm2 c896x">
                                                            <label className="cc9lh cw7u7 c4ozt cjmb3 c62tk c50dd cq72s c65xn cusnp" htmlFor="company-size">Company size</label>
                                                            <div className="ce0su c1dbb cvs2y">
                                                                <select
                                                                    id="company-size"
                                                                    name="companySize"
                                                                    className="ch4gi cjkjb cmxc3 c62tk"
                                                                    value={formData.companySize}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                >
                                                                    <option value="1">1</option>
                                                                    <option value="2-10">2-10</option>
                                                                    <option value="10-20">10-20</option>
                                                                    <option value="20-50">20-50</option>
                                                                    <option value="50-100">50-100</option>
                                                                    <option value="100-500">100-500</option>
                                                                    <option value="500-1000">500-1000</option>
                                                                    <option value="1000-5000">1000-5000</option>
                                                                    <option value="5000+">5000+</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="cdjl1 crjhh c5mm2 c896x">
                                                            <label className="cc9lh cw7u7 c4ozt cjmb3 c62tk c50dd cq72s c65xn cusnp" htmlFor="country">Country</label>
                                                            <div className="ce0su c1dbb cvs2y">
                                                                <input
                                                                    id="country"
                                                                    name="country"
                                                                    className="cfjie cjkjb cmxc3 c62tk"
                                                                    type="text"
                                                                    placeholder="United States"
                                                                    value={formData.country}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="cdjl1 crjhh c5mm2 c896x">
                                                            <label className="cc9lh cw7u7 c4ozt cjmb3 c62tk c50dd cq72s c65xn cusnp" htmlFor="comment">Your Message</label>
                                                            <div className="ce0su c1dbb cvs2y">
                                                                <textarea
                                                                    id="comment"
                                                                    name="message"
                                                                    className="cih9a cjkjb cmxc3 c62tk"
                                                                    rows={4}
                                                                    value={formData.message}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="c6n45 cf1hj">
                                                        <button
                                                            type="submit"
                                                            disabled={isSubmitting}
                                                            className="cn4p0 c98p9 c38qt ckk70 cyuce co504 cv52j ck31x disabled:opacity-50 disabled:cursor-not-allowed"
                                                        >
                                                            {isSubmitting ? 'Sending...' : 'Submit the form'}
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </>
    )
}

export default Contact;